// Realistic Turkish content for blog posts and portfolio case studies.

export const BLOG_POSTS = [
  {
    slug: "2026-web-tasarim-trendleri",
    title: "2026'da Web Tasarım Trendleri Neler Olacak?",
    excerpt:
      "Minimalist arayüzler, mikro-animasyonlar ve AI destekli kişiselleştirme — yeni dönemde öne çıkacak başlıklar.",
    category: "Tasarım",
    date: "12 Aralık 2025",
    readTime: "6 dk okuma",
    author: "AjansBilir Ekibi",
    img: "https://images.unsplash.com/photo-1683721003111-070bcc053d8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    content: [
      {
        type: "p",
        text:
          "2026 yılına girerken kullanıcılar artık bir web sitesinden sadece bilgi almayı değil, anlık olarak bir deneyim yaşamayı bekliyor. Tasarım kararlarımız hız, sadelik ve duygusal bağ üçgeninde şekilleniyor. Bu yazıda önümüzdeki yılın öne çıkacak 6 büyük trendini ve bu trendlerin işletmeniz için ne anlama geldiğini ele alıyoruz.",
      },
      { type: "h", text: "1. Sade ama karakterli arayüzler" },
      {
        type: "p",
        text:
          "Minimalist tasarım yeni değil; ancak 2026'nın minimalizmi 'soğuk' değil 'kişilikli'. Markanın sesini taşıyan büyük başlıklar, geniş boşluklar ve tek bir vurgu rengi öne çıkıyor. AjansBilir olarak müşterilerimizin sayfalarında bu yaklaşımı benimseyerek dönüşüm oranlarında ortalama %38 artış sağlıyoruz.",
      },
      { type: "h", text: "2. Mikro-animasyonlar ve hareket katmanları" },
      {
        type: "p",
        text:
          "Buton hover'ları, kart geçişleri ve sayfa içi kaydırma animasyonları artık standart. Önemli olan animasyonun amaca hizmet etmesi: kullanıcının dikkatini yormadan yönlendirmek. Framer Motion ve CSS transform tabanlı çözümler hız kaybı yaşatmadan bu deneyimi sunuyor.",
      },
      { type: "h", text: "3. AI destekli kişiselleştirme" },
      {
        type: "p",
        text:
          "Ziyaretçinin geldiği kaynağa, saate veya cihaza göre içerikleri değiştiren akıllı bölümler 2026'nın en güçlü silahı. Restoranlar için 'öğle menüsü', mağazalar için 'bölgenize özel kampanya' gibi dinamik bloklar tıklama oranlarını ikiye katlıyor.",
      },
      { type: "h", text: "4. Mobil öncelikli içerik mimarisi" },
      {
        type: "p",
        text:
          "Türkiye'de trafiğin %78'inden fazlası mobilden geliyor. Bu yüzden 2026 tasarımları artık 'masaüstünden mobile' değil, 'mobilden masaüstüne' kuruluyor. Başparmak bölgesine yerleştirilen WhatsApp ve telefon CTA'ları, anlık dönüşümün anahtarı.",
      },
      { type: "h", text: "5. Hız bir özellik değil, zorunluluk" },
      {
        type: "p",
        text:
          "Google'ın Core Web Vitals metrikleri SEO sıralamasını doğrudan etkiliyor. 2 saniyenin altında açılan siteler hem reklam kalitesinde hem organik trafikte öne geçiyor. Modern CDN, görsel optimizasyonu ve component-bazlı yüklemeler artık 'lüks' değil 'standart'.",
      },
      { type: "h", text: "6. Erişilebilirlik ve karanlık mod" },
      {
        type: "p",
        text:
          "Renk kontrastı, klavye navigasyonu ve ekran okuyucu uyumu artık yasal bir zorunluluğa dönüşüyor. Bunun yanında kullanıcılar gece kullanım için karanlık mod beklentisi içinde.",
      },
      { type: "h", text: "Peki siz ne yapmalısınız?" },
      {
        type: "p",
        text:
          "Bu trendlerin tamamını birden uygulamak gerekmiyor; önemli olan markanızın hedefine en yakın olanları seçmek. AjansBilir olarak ücretsiz bir dijital sağlık taraması ile mevcut sitenizin hangi alanlarda gelişebileceğini gösteriyoruz. WhatsApp'tan yazın, 30 dakikalık ücretsiz danışmanlık planlayalım.",
      },
    ],
  },
  {
    slug: "google-ads-yerel-isletme-buyume",
    title: "Google Ads ile Yerel İşletmenizi Nasıl Büyütürsünüz?",
    excerpt:
      "Lokal arama reklamlarını ve Performance Max kampanyalarını verimli kullanmanın püf noktaları.",
    category: "Reklam",
    date: "5 Aralık 2025",
    readTime: "8 dk okuma",
    author: "AjansBilir Ekibi",
    img: "https://images.pexels.com/photos/106344/pexels-photo-106344.jpeg",
    content: [
      {
        type: "p",
        text:
          "Berber, klinik, restoran, oto servis, kuaför… Yerel hizmet veren bir işletme iseniz müşteriniz çoğu zaman cep telefonunu eline alıp 'yakınımda' diye arama yapıyor. İşte tam bu anı yakalamak Google Ads'in temel mantığıdır. Doğru kurgulanmış bir kampanya, mağazanızın kapısının önünde duran insanlara fısıldamak gibidir.",
      },
      { type: "h", text: "1. Önce Google Business Profile" },
      {
        type: "p",
        text:
          "Google'da reklam vermeden önce işletmenizin Google Business Profile'ı tamamen doldurulmuş olmalı: doğru kategori, çalışma saatleri, fotoğraflar, hizmetler ve müşteri yorumları. Bu profil reklamlarınızın 'kalite puanını' yukarı çekiyor.",
      },
      { type: "h", text: "2. Doğru kampanya tipi seçimi" },
      {
        type: "p",
        text:
          "Yerel işletmeler için en verimli iki kampanya tipi: Arama Ağı ve Performance Max. Arama Ağı kampanyaları 'niyetli' kullanıcıyı yakalar; Performance Max ise Maps, YouTube, Gmail ve Display ağına aynı anda dağılarak hedef kitlenizi her noktada hatırlatır.",
      },
      { type: "h", text: "3. Anahtar kelime yerine niyet" },
      {
        type: "p",
        text:
          "Eski usul 'beylikdüzü diş hekimi' yazmak yetmez. Müşteriniz gerçekte 'çocuğum için diş ağrısı acil', 'hızlı diş beyazlatma fiyat' gibi sorgular yazıyor. Long-tail anahtar kelimeleri içeren bir negatif liste ile birlikte hedefler ROI'yi ikiye katlar.",
      },
      { type: "h", text: "4. Reklam metinleri ve uzantılar" },
      {
        type: "p",
        text:
          "Sitemize gelen tıklamanın gücü, reklam metnindeki 3 unsura bağlı: belirgin bir kazanç ('aynı gün randevu'), bir aciliyet vurgusu ('bugün arayanlara %15 indirim') ve bir güven sinyali ('+1.200 mutlu müşteri'). Site bağlantı uzantıları ve telefon uzantıları tıklama oranını %43'e kadar artırıyor.",
      },
      { type: "h", text: "5. Dönüşüm takibi olmadan reklam yapmayın" },
      {
        type: "p",
        text:
          "Telefon aramaları, WhatsApp tıklamaları, form gönderimleri ve yol tarifi tıklamaları mutlaka 'conversion' olarak işaretlenmeli. Aksi halde hangi anahtar kelimenin gerçekten iş getirdiğini bilemezsiniz.",
      },
      { type: "h", text: "6. Bütçeyi nasıl belirlemeli?" },
      {
        type: "p",
        text:
          "Tecrübemize göre yerel bir işletme için aylık 3.000-6.000 TL arası bir başlangıç bütçesi anlamlı sonuçlar veriyor. İlk ay test bütçesi, ikinci ay optimize, üçüncü ay ölçeklendirme prensibiyle ilerliyoruz.",
      },
      { type: "h", text: "Sonuç" },
      {
        type: "p",
        text:
          "Doğru kurgulanmış bir Google Ads kampanyası, yerel işletmenizin en güvenilir 'kapı önü görevlisi' olur. Ücretsiz reklam analizimiz için WhatsApp'tan ulaşın; mevcut kampanyalarınızda hangi noktalarda kayıp olduğunu birlikte görelim.",
      },
    ],
  },
  {
    slug: "whatsapp-business-gizli-ozellikler",
    title: "WhatsApp Business'ın Gizli Kalmış 5 Özelliği",
    excerpt:
      "Katalog, otomatik mesajlar, etiketleme ve daha fazlası ile WhatsApp'ı satış kanalı haline getirin.",
    category: "Sosyal Medya",
    date: "28 Kasım 2025",
    readTime: "5 dk okuma",
    author: "AjansBilir Ekibi",
    img: "https://images.pexels.com/photos/317154/pexels-photo-317154.jpeg",
    content: [
      {
        type: "p",
        text:
          "Türkiye'de WhatsApp, müşterilerin işletmelerle iletişim kurmak için kullandığı 1 numaralı kanal. Ancak çoğu işletme WhatsApp Business uygulamasının yalnızca selamlama mesajı özelliğini kullanıyor. Halbuki içinde küçük bir CRM gibi çalışan, satışı katlayan 5 müthiş özellik var.",
      },
      { type: "h", text: "1. Katalog özelliği" },
      {
        type: "p",
        text:
          "Ürün veya hizmetlerinizi fotoğrafıyla, fiyatıyla ve açıklamasıyla WhatsApp profilinize ekleyebilirsiniz. Müşteri sohbet ekranından doğrudan ürünü görüp 'bu ürünü istiyorum' butonuyla size mesaj atabiliyor. Tıklama-mesaj dönüşümünü ortalama %62 artırıyor.",
      },
      { type: "h", text: "2. Hızlı yanıtlar (Quick Replies)" },
      {
        type: "p",
        text:
          "'/fiyat', '/randevu', '/adres' gibi kısayollarla 1 saniyede hazır cevap gönderebilirsiniz. Hem müşteri bekletilmez hem de ekibinizin gün içindeki tekrarlı yükü %70 azalır.",
      },
      { type: "h", text: "3. Etiketler ve müşteri segmentasyonu" },
      {
        type: "p",
        text:
          "Müşterilerinizi 'Yeni Talep', 'Teklif Aşamasında', 'Satın Aldı', 'Düzenli Müşteri' gibi etiketlere ayırabilirsiniz. Daha sonra bu etiketlere özel kampanya mesajları gönderebilirsiniz.",
      },
      { type: "h", text: "4. Otomatik karşılama ve uzakta mesajı" },
      {
        type: "p",
        text:
          "Mesai dışı saatlerde otomatik 'Merhaba, en kısa sürede dönüş yapacağız' mesajı; ilk mesaj atan müşteriye otomatik 'Aramıza hoş geldiniz' karşılaması. Hiç kimseyi cevapsız bırakmazsınız.",
      },
      { type: "h", text: "5. WhatsApp Business API + otomasyon" },
      {
        type: "p",
        text:
          "İşletmeniz belli bir büyüklüğe ulaştığında WhatsApp Business API'ye geçmek mümkün. Bu sayede yüzlerce müşteriye aynı anda kampanya mesajı, randevu hatırlatma, sipariş durumu güncellemesi gibi otomasyonlar yapılabilir. AjansBilir olarak bu API entegrasyonlarını anahtar teslim kuruyoruz.",
      },
      { type: "h", text: "Hadi başlayalım" },
      {
        type: "p",
        text:
          "WhatsApp Business'ı en verimli şekilde kurmak için 30 dakikalık ücretsiz oturum açıyoruz. WhatsApp'tan 'kurulum' yazarak bize ulaşabilirsiniz.",
      },
    ],
  },
];

export const PORTFOLIO_PROJECTS = [
  {
    slug: "e-ticaret-donusum-optimizasyonu",
    title: "E-Ticaret Dönüşüm Optimizasyonu",
    client: "Modabella Butik · Online Mağaza",
    category: "Web Tasarım & Google Ads",
    duration: "3 ay",
    year: "2025",
    metric: "+%240",
    metricLabel: "Dönüşüm Artışı",
    img: "https://images.pexels.com/photos/326514/pexels-photo-326514.jpeg",
    summary:
      "Yıllarca düşük dönüşüm oranıyla satış yapan bir online butiğin sitesini sıfırdan tasarladık ve Google Ads kampanyalarını yeniden kurguladık.",
    challenge:
      "Müşterimizin eski WordPress tabanlı sitesi 6 saniyenin üzerinde yükleniyor, mobilde sepete ulaşma adımı 4 tıklama sürüyor ve Google Ads kampanyaları tek bir kampanyada 800'den fazla anahtar kelimeyle dağılmış durumdaydı. Sonuç: ziyaretçi başı maliyet yüksek, dönüşüm düşük.",
    solution: [
      "Next.js tabanlı, görsel optimizasyonlu yeni sitenin sıfırdan kurulması",
      "Sepete ekleme adımının 2 tıklamaya indirilmesi ve 'misafir kullanıcı' alışveriş",
      "Google Ads kampanyalarının kategori bazlı 12 ayrı kampanyaya bölünmesi",
      "Performance Max kampanyası + Smart Shopping Feed entegrasyonu",
      "Sepeti terk eden kullanıcılar için otomatik WhatsApp mesajı kurgusu",
    ],
    results: [
      { k: "Dönüşüm Oranı", v: "%0.9 → %3.1" },
      { k: "Ziyaretçi Başı Maliyet", v: "-%48" },
      { k: "Sayfa Yükleme Süresi", v: "6.1 sn → 1.4 sn" },
      { k: "ROAS", v: "1.7x → 6.8x" },
    ],
    quote:
      "Sitemiz değişti, hayatımız değişti. Artık reklam vermek 'umuyoruz tutar' değil, 'bu hafta da tuttu' diyebildiğimiz bir süreç.",
    quoteBy: "Modabella, Pazarlama Sorumlusu",
  },
  {
    slug: "yerel-isletme-sosyal-medya",
    title: "Yerel İşletme Sosyal Medya Patlaması",
    client: "Atelier Mavi · Beylikdüzü Cafe",
    category: "Instagram Reklamları & İçerik",
    duration: "4 ay",
    year: "2025",
    metric: "1.2M",
    metricLabel: "Aylık Gösterim",
    img: "https://images.pexels.com/photos/6956303/pexels-photo-6956303.jpeg",
    summary:
      "Yeni açılan bir kafe için sıfırdan Instagram stratejisi kurduk; 4 ay sonunda mahallenin en bilinen markası haline geldi.",
    challenge:
      "Müşterimiz şehrin yeni açılan bir bölgesinde, rekabetin yoğun olduğu bir noktada lokasyon almıştı. Açılışın ilk ayında günde sadece 18-20 kişi ağırlanabiliyordu. Instagram hesabı vardı ama içerik düzensizdi.",
    solution: [
      "Markanın tonunu belirleyen yeni bir görsel kimlik hazırlığı",
      "Haftada 4 Reels, 3 carousel ve 5 hikaye paylaşımına dayalı içerik takvimi",
      "Beylikdüzü 5 km yarıçap hedeflemesiyle Instagram reklamları",
      "Mikro-influencer iş birlikleri (her ay 4 yerel etkileyici)",
      "Müşteri yorumlarını kullanan UGC (kullanıcı içeriği) odaklı paylaşım stratejisi",
    ],
    results: [
      { k: "Takipçi", v: "240 → 18.4K" },
      { k: "Aylık Gösterim", v: "1.2M" },
      { k: "Günlük Müşteri", v: "20 → 140+" },
      { k: "Tekrar Gelme Oranı", v: "%62" },
    ],
    quote:
      "Mahalle bizi 'Instagram'daki kafe' olarak biliyor. Hafta sonu masa bulmak için randevu sistemine geçmek zorunda kaldık — iyi anlamda.",
    quoteBy: "Atelier Mavi, Kurucu",
  },
  {
    slug: "klinik-randevu-yonetim-sistemi",
    title: "Klinik Randevu Yönetim Sistemi",
    client: "Doruk Klinik · Estetik & Dermatoloji",
    category: "Sistem Entegrasyonu",
    duration: "6 hafta",
    year: "2025",
    metric: "50+",
    metricLabel: "Günde Otomatik Randevu",
    img: "https://images.unsplash.com/photo-1695048132783-4b9f77bde5be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    summary:
      "5 hekimin çalıştığı estetik kliniği için web sitesi, online randevu sistemi ve WhatsApp otomasyon altyapısını tek panelde birleştirdik.",
    challenge:
      "Klinikte tek bir resepsiyonist 5 hekim için telefonla randevu yönetiyordu. Yoğun saatlerde aramalar cevapsız kalıyor, randevu çakışmaları yaşanıyor, hatırlatma mesajları manuel atılıyordu. Aylık iptal/no-show oranı %22'ye kadar çıkmıştı.",
    solution: [
      "Hekim bazlı müsaitlik takvimi olan özel randevu yazılımı",
      "Müşterinin web sitesinden 60 saniyede randevu alabilmesi",
      "Randevudan 24 saat önce otomatik WhatsApp hatırlatma + onay butonu",
      "İptal/değişiklik durumunda hekime ve resepsiyona otomatik bildirim",
      "Yönetici paneli üzerinden günlük, haftalık ve aylık doluluk raporu",
    ],
    results: [
      { k: "Günlük Otomatik Randevu", v: "50+" },
      { k: "No-show Oranı", v: "%22 → %6" },
      { k: "Resepsiyon Yükü", v: "-%70" },
      { k: "Müşteri Memnuniyeti", v: "4.9 / 5" },
    ],
    quote:
      "Artık telefonun başında oturmuyoruz. Sistem kendi kendine çalışıyor, biz hasta deneyimine odaklanabiliyoruz.",
    quoteBy: "Doruk Klinik, Klinik Yöneticisi",
  },
  {
    slug: "restoran-siparis-takip-paneli",
    title: "Restoran Sipariş Takip Paneli",
    client: "Lezzet Durağı · Aile Restoranı Zinciri",
    category: "Yazılım & WhatsApp",
    duration: "2 ay",
    year: "2025",
    metric: "%34",
    metricLabel: "Sipariş Hatasında Azalma",
    img: "https://images.pexels.com/photos/7654117/pexels-photo-7654117.jpeg",
    summary:
      "3 şubeli bir restoran zinciri için merkezi sipariş takip ve mutfak ekranı sistemi geliştirdik.",
    challenge:
      "Sipariş kayıtları kağıt fişe yazılıyor, mutfak ile garsonlar arasında karışıklık yaşanıyordu. Müşterilere paket sipariş durumu hakkında bilgi vermek için sürekli aranıyor, doğru bilgi verilemiyordu. Aylık şikayet oranı yüksekti.",
    solution: [
      "Garsonların tablet üzerinden sipariş alabildiği POS arayüzü",
      "Mutfak ekranında otomatik açılan canlı sipariş kuyruğu",
      "Paket sipariş için müşteriye 'Hazırlanıyor / Yola Çıktı / Teslim Edildi' aşamalarında otomatik WhatsApp bildirim",
      "Yönetici paneli üzerinden saatlik ciro, en çok satan ürün ve kurye performans raporu",
      "Şube bazlı stok ve maliyet entegrasyonu",
    ],
    results: [
      { k: "Sipariş Hatası", v: "-%34" },
      { k: "Müşteri Bilgilendirme", v: "Otomatik %100" },
      { k: "Mutfak Hazırlık Süresi", v: "-%18" },
      { k: "Aylık Şikayet", v: "32 → 4" },
    ],
    quote:
      "Şubeler arasında artık 'tahmin' yok, veri var. Her şubenin saatlik durumunu cebimden takip ediyorum.",
    quoteBy: "Lezzet Durağı, İşletme Sahibi",
  },
];
